<template>
  <div
    class="d-flex justify-center align-center score-pop"
    :style="{ gap: '4px', marginTop: marginTop, minHeight: '40px' }"
  >
    <template v-if="winnerName">
      <v-icon class="text-title-medium mr-1" color="primary">mdi-trophy</v-icon>
      <span :class="['text-title-medium', 'font-weight-bold', 'text-primary', scoreTextClass]">{{ winnerName }}</span>
    </template>
    <template v-else-if="dash">
      <div class="d-flex flex-column align-center justify-center" style="flex: 1; min-width: 100px;">
        <span v-if="hints?.[0] != null" class="text-caption font-weight-medium text-primary">Just need {{ hints[0] }}</span>
      </div>
      <span :class="[size, 'font-weight-bold', 'text-primary']">–</span>
      <div class="d-flex flex-column align-center justify-center" style="flex: 1; min-width: 100px;">
        <span v-if="hints?.[1] != null" class="text-caption font-weight-medium text-primary">Just need {{ hints[1] }}</span>
      </div>
    </template>
    <template v-else>
      <span :class="['mx-1', size, 'font-weight-bold', 'text-primary', scoreTextClass]">{{ left }}</span>
      <span :class="[size, 'font-weight-bold', 'text-primary', scoreTextClass]">–</span>
      <span :class="['mx-1', size, 'font-weight-bold', 'text-primary', scoreTextClass]">{{ right }}</span>
    </template>
  </div>
</template>

<script>
export default {
  name: "ScoreDisplay",
  props: {
    left: {
      type: Number,
      default: null
    },
    right: {
      type: Number,
      default: null
    },
    dash: {
      type: Boolean,
      default: false
    },
    marginTop: {
      type: String,
      default: "12px"
    },
    hints: {
      type: Array,
      default: () => []
    },
    size: {
      type: String,
      default: "text-headline-large"
    },
    winnerName: {
      type: String,
      default: ""
    },
    scoreShadow: {
      type: String,
      default: "fade"
    }
  },
  computed: {
    scoreTextClass () {
      if (this.scoreShadow === "none") return "";
      if (this.scoreShadow === "persist") return "score-text--persist";
      return "score-text";
    }
  }
};
</script>

<style scoped>
.score-pop {
  animation: scorePop .2s ease-out;
}
.score-text {
  animation: elevationFade 60s ease forwards;
}
.score-text--persist {
  text-shadow: 3px 2px 0 rgba(0,0,0,0.1), 1px 2px 5px rgba(0,0,0,0.15);
}
@keyframes scorePop {
  from { transform: scale(0.5); opacity: 0; }
  to { transform: scale(1); opacity: 1; }
}
@keyframes elevationFade {
  from { text-shadow: 3px 2px 0 rgba(0,0,0,0.1), 1px 2px 5px rgba(0,0,0,0.15); }
  to   { text-shadow: 0 0 0 transparent, 0 0 0 transparent; }
}
</style>
